// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"775":"950dd631","935":"38360618"}[chunkId] + ".js";
};